import { setObjects } from '../helpers';
import Vue from 'vue';

const initialState = () => ({
    storage: { },
})

const mutations = {
    ADD_SUBMISSIONS (state, submissions) {
        setObjects(submissions, state.storage)
    },
    SET_SUBMISSION(state, submission) {
        setObjects([submission], state.storage)
    },
    FREEZE_SUBMISSIONS(state, ids) {
        ids.forEach( id => state.storage[id].isFrozen = true)
    },
    UPDATE_SUBMISSION(state, id, data) {
        state.storage[id].data = data
    },
    REMOVE_SUBMISSION(state, id) {
        Vue.delete(state.storage, id)
    }
}

export default {
    initialState,
    state: initialState(),
    mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/submissions.js